import angular from 'angular';
import moment from 'moment';

import templateUrl from './product-commission-policy-list.component.html'

export const ProductCommissionPolicyListComponent = {
    templateUrl,
    controller: ProductCommissionPolicyListController,
    controllerAs: "vm",
    bindings: {
        division: "<",
        autoProductLine: "<"
    }
};

function ProductCommissionPolicyListController($q, $window, productCommissionPolicyService,
    productCommissionPolicyArchiveService, divisionService, productsService,
    productLinesService, utilityService) {
    'ngInject';

    const vm = this;
    vm.autoProductLine;
    vm.pristineProductCommissionPolicies;
    vm.productCommissionPolicies = [];
    vm.products;
    vm.productLines;
    vm.productCode;
    vm.divisions;
    vm.division;
    vm.today = moment().toDate();
    vm.loaded = false;
    vm.submitting = false;
    vm.showFilters = false;
    vm.filters = {};
    vm.categories = productLinesService.getRogersCategories();
    vm.filterDivisionPolicy = filterDivisionPolicy;
    vm.filterProductCommissionPolicy = filterProductCommissionPolicy;
    vm.onCreateNewProductCommissionPolicy = onCreateNewProductCommissionPolicy;
    vm.onDeleteProductCommissionPolicy = onDeleteProductCommissionPolicy;
    vm.onValidateProductCommissionPolicy = onValidateProductCommissionPolicy;
    vm.onEditOtherProductCommissionPolicy = onEditOtherProductCommissionPolicy;
    vm.onSaveAll = onSaveAll;
    vm.onCancel = onCancel;
    vm.$onChanges = onChanges;

    $window.onbeforeunload = onBeforeUnload;

    return;
    function onChanges(changes) {
        if (changes.division.currentValue) {
            vm.division = changes.division.currentValue;
            activate();
        }
    }
    function activate() {
        $q.when(utilityService.showLoading())
            .then(loadInitialData)
            .then(function () {
                vm.loaded = true;
                vm.pristineProductCommissionPolicies = angular.copy(vm.productCommissionPolicies);
            })
            .catch(function (ex) {
                $.winxnetAlertWindow({ message: "Initial load failed: " + utilityService.getExceptionMessage(ex) });
            })
            .then(utilityService.hideLoading);
    }

    function loadInitialData() {

        const getProducts = productsService.retrieveProducts();
        const getProductLines = productLinesService.retrieveProductLines();
        const productCommision = productCommissionPolicyService.retrieveProductCommissionPolicies();

        return $q.all([getProducts, getProductLines, productCommision])
            .then(function ([products, productLines, productCommissionPolicies]) {
                vm.productLines = productLines.filter(function (event) {
                    return vm.division.Id === event.DivisionID
                }).map(itm => ({
                    //Combining product lines with categories
                    ...vm.categories.find((item) => item.CategoryID === itm.ProductCategory && item),
                    ...itm
                }));

                vm.products = products.filter(function (event) {
                    return vm.division.Id === event.DivisionID
                })
                    .sort((a, b) => a.Name < b.Name ? -1 : 1)
                    .map(itm => ({
                        //Combining products with product lines by ProductLineID
                        ...vm.productLines.find((item) => item.ProductLineID === itm.ProductLineID && item),
                        ...itm
                    }));
                vm.pristineProductCommissionPolicies = loadDivisionProductCommissionPolicies(
                    productCommissionPolicies, vm.products, vm.productLines);
                vm.productCommissionPolicies = angular.copy(vm.pristineProductCommissionPolicies);
            });
    }

    function loadDivisionProductCommissionPolicies(productCommissionPolicies, products, productLines) {
        // Group the policies by division.
        const divisionPolicies = productCommissionPolicies.reduce(function (divisionPoliciesSet, policy) {

            policy.Product = products.filter(function (product) {
                return product.ProductID === policy.ProductID;
            })[0];
            policy.ProductLine = productLines.filter(function (productLine) {
                return productLine.ProductLineID === policy.ProductLineID;
            })[0];
            policy.ActivePolicy = policy.Archives.sort(function (a, b) {
                if (a.ActiveOrderStart < b.ActiveOrderStart) {
                    return 1;
                } else if (a.ActiveOrderStart > b.ActiveOrderStart) {
                    return -1;
                } else {
                    if (a.ActiveInstalledStart < b.ActiveInstalledStart) {
                        return 1;
                    } else if (a.ActiveInstalledStart > b.ActiveInstalledStart) {
                        return -1;
                    } else {
                        return 0;
                    }
                }
            })[0];

            policy.Locked = policy.Archives.reduce(function (locked, archive) {
                return locked || archive.Locked;
            }, false);
            if (policy.Product) {
                let divisionPolicies = divisionPoliciesSet[policy.Product.DivisionID];
                if (divisionPolicies === undefined) {
                    divisionPolicies = {
                        DivisionID: policy.Product.DivisionID,
                        DivisionName: policy.Product.DivisionName,
                        CommissionPolicies: []
                    };
                    divisionPoliciesSet[policy.Product.DivisionID] = divisionPolicies;
                }
                divisionPolicies.CommissionPolicies.push(policy);
            }

            return divisionPoliciesSet;
        }, {});

        return Object.values(divisionPolicies)
            .sort(function (a, b) {
                // Sort the list by division name.
                return a < b ? -1 : 1;
            }).filter(function (event) {
                return vm.division.Id === event.DivisionID
            });


    }

    function filterDivisionPolicy(divisionPolicy) {
        return divisionPolicy.CommissionPolicies.filter(filterProductCommissionPolicy).length > 0;
    }

    function filterProductCommissionPolicy(productCommissionPolicy) {
        return !productCommissionPolicy.IsDeleted
            && (productCommissionPolicy.IsNew ||
                (!vm.filters.product || !productCommissionPolicy.Product
                    || productCommissionPolicy.Product.Name.toLowerCase()
                        .indexOf(vm.filters.product.toLowerCase()) > -1)
                && (!vm.filters.productLine || !productCommissionPolicy.ProductLine
                    || productCommissionPolicy.ProductLine.Name.toLowerCase()
                        .indexOf(vm.filters.productLine.toLowerCase()) > -1)
                // boolean autoProductLine has a special meaning. Namely, that the product line should auto-select
                // to the product's own product line.
                && (vm.autoProductLine !== true || productCommissionPolicy.ProductLineID
                    === productCommissionPolicy.Product.ProductLineID)
                // non-boolean truthy autoProductLine means that the product line should be selected by the given name.
                && (!vm.autoProductLine || vm.autoProductLine === true
                    || productCommissionPolicy.ProductLine.ProductLineCode === vm.autoProductLine))
            && (!vm.filters.productCode || !productCommissionPolicy.Product.ProductCode
                || productCommissionPolicy.Product.ProductCode.toLowerCase()
                    .indexOf(vm.filters.productCode.toLowerCase()) > -1);
    }

    function onValidateProductCommissionPolicy(productCommissionPolicy) {
        const productCommissionPolicies = vm.productCommissionPolicies
            .reduce(function (productCommissionPolicies, divisionPolicy) {
                productCommissionPolicies.push(...divisionPolicy.CommissionPolicies);
                return productCommissionPolicies;
            }, []);

        const anyDuplicates = productCommissionPolicyService.duplicateProductCommissionPolicyExists(
            productCommissionPolicy, productCommissionPolicies);
        productCommissionPolicy.editForm.$setValidity("unique", !anyDuplicates);
    }

    function onEditOtherProductCommissionPolicy(productCommissionPolicy) {
        if (!productCommissionPolicy.Product || !productCommissionPolicy.ProductLine) {
            return;
        }
        // Find the commission policy that has the same program and store as the one passed in.
        const duplicate = vm.productCommissionPolicies.reduce(function (duplicate, divisionPolicy) {
            return duplicate || divisionPolicy.CommissionPolicies.reduce(function (duplicate, other) {
                return duplicate || other !== productCommissionPolicy && other.Product
                    && other.Product.ProductID === productCommissionPolicy.Product.ProductID
                    && other.ProductLine
                    && other.ProductLine.ProductLineID === productCommissionPolicy.ProductLine.ProductLineID
                    && other;
            }, false);
        }, false);

        if (duplicate) {
            // Delete this commission policy and edit the duplicate instead.
            onDeleteProductCommissionPolicy(productCommissionPolicy);
            duplicate.isOpen = true;
        }

    }

    function onCreateNewProductCommissionPolicy() {
        const newPolicy = {
            IsNew: true,
            IsDeleted: false,
            ProductID: null,
            ProductLineID: null,
            Archives: [],
            isOpen: true

        };

        const newArchive = productCommissionPolicyArchiveService.addArchive(newPolicy);
        newArchive.isOpen = true;
        let newProductCommissionDivision = vm.productCommissionPolicies.filter(function (division) {
            return division.DivisionID === null;
        })[0];

        if (!newProductCommissionDivision) {
            newProductCommissionDivision = {
                DivisionID: null,
                DivisionName: "New Product Commission Policies",
                CommissionPolicies: []
            };
            vm.productCommissionPolicies.unshift(newProductCommissionDivision);
        }
        newProductCommissionDivision.CommissionPolicies.unshift(newPolicy);
        vm.editForm.$setDirty(true);
    }

    function onDeleteProductCommissionPolicy(productCommissionPolicy) {
        if (productCommissionPolicy.Locked) {
            throw "Cannot delete a product commission policy because it is locked";
        }
        if (productCommissionPolicy.IsDeleted || !productCommissionPolicy.IsNew && !confirm("The policy will be deleted after you click Save.")) {
            // Clicking delete a second time toggles IsDeleted back off.
            productCommissionPolicy.IsDeleted = false;
            return;
        }
        vm.editForm.$setDirty(true);
        productCommissionPolicy.IsDeleted = true;
    }

    function onSaveAll() {
        if (!vm.editForm.$valid) {
            alert("Not valid.");
        }
        utilityService.showLoading();
        vm.submitting = true;
        let requests = [];
        requests = vm.productCommissionPolicies.reduce(function (requests, groupedCommisionPolicies) {
            groupedCommisionPolicies.CommissionPolicies.forEach(function (groupedPolicy) {
                const saveRequests = groupedPolicy.Archives.filter(function (archive) {
                    return !archive.IsNew && archive.IsDeleted || archive.editForm && archive.editForm.$dirty;
                }).map(function (archive) {
                    const policy = {};
                    policy.ProductID = groupedPolicy.ProductID;
                    policy.ProductLineID = groupedPolicy.ProductLineID;
                    policy.ActiveInstalledStart = archive.ActiveInstalledStart ?
                        moment(archive.ActiveInstalledStart).format("YYYY-MM-DD") : null;
                    policy.ActiveInstalledEnd = archive.ActiveInstalledEnd ?
                        moment(archive.ActiveInstalledEnd).format("YYYY-MM-DD") : null;
                    policy.ActiveOrderStart = archive.ActiveOrderStart ?
                        moment(archive.ActiveOrderStart).format("YYYY-MM-DD") : null;
                    policy.ActiveOrderEnd = archive.ActiveOrderEnd ?
                        moment(archive.ActiveOrderEnd).format("YYYY-MM-DD") : null;
                    policy.Amount = archive.Amount;
                    policy.IsNew = archive.IsNew;
                    policy.IsDeleted = archive.IsDeleted;
                    policy.ProductCommissionID = archive.ProductCommissionID;
                    return policy;
                });
                requests.push(...saveRequests);
            });
            return requests;
        }, []);

        productCommissionPolicyService.bulkUpsetProductCommision(requests)
            .then(function () {
                return productCommissionPolicyService.retrieveProductCommissionPolicies();
            })
            .then(function (productcommissionPolicies) {
                return loadDivisionProductCommissionPolicies(productcommissionPolicies, vm.products, vm.productLines);
            })
            .then(function (productcommissionPolicies) {
                vm.pristineProductCommissionPolicies = productcommissionPolicies;
                vm.productCommissionPolicies = angular.copy(vm.pristineProductCommissionPolicies);
                vm.editForm.$setPristine(true);
            })
            .catch(function (ex) {
                console.error(ex);
                $.winxnetAlertWindow({ message: "Saving failed: " + utilityService.getExceptionMessage(ex) });
            })
            .then(function () {
                vm.submitting = false;
                utilityService.hideLoading()
            });
    }

    function onCancel() {
        vm.productCommissionPolicies = angular.copy(vm.pristineProductCommissionPolicies);
        vm.editForm.$setPristine(true);
    }

    function onBeforeUnload() {
        if (vm.editForm && vm.editForm.$dirty) {
            return "You have unchanged changes that will be lost if you leave the page.";
        }
    }
}
